import $ from 'jquery';
import getLayout from './get-modal-layout';
import Modal from './modal';


class Modal3dTour extends Modal {
  constructor() {
    super();
    this.container = null;
    this.lang = document.querySelector(`body`).dataset.lang;
  }

  init(toggles) {
    this.toggles = toggles;
    super.createModal();
    this.createPlansWrap();
    this.bindHandlers();
  }

  toggleModal = (isModalShown) => {
    super._toggleModal(isModalShown);
  };

  createPlansWrap() {
    super.addLayout(getLayout(`modal-3d`));
    this.container = this.page.querySelector('.tour-3d');
  };

  bindHandlers() {
    if (this.toggles.length) {
      this.toggles.forEach(toggle => {
        if (toggle) {
          toggle.addEventListener(`click`, (ev) => {
            ev.preventDefault();
            let tourLink = toggle.dataset.link3d;
            this.container.querySelector('iframe').setAttribute('src', tourLink + '&play=1');
            this.toggleModal(true);
          });
        }
      })
    } else if (this.toggles && this.toggles.length !== 0) {
      this.toggles.addEventListener(`click`, (ev) => {
        ev.preventDefault();
        let tourLink = this.toggles.dataset.link3d;
        this.container.querySelector('iframe').setAttribute('src', tourLink + '&play=1');
        this.toggleModal(true);
      });
    }
  }
}

const modal3dTour = new Modal3dTour();

export default modal3dTour;
